module.exports = __webpack_public_path__ + "static/Discovery-3c57f30991b99a72a04b3dcda45a953d.png";